import { render } from "./HorizontalOption.vue?vue&type=template&id=4d230bd8&scoped=true&ts=true"
import script from "./HorizontalOption.vue?vue&type=script&lang=ts"
export * from "./HorizontalOption.vue?vue&type=script&lang=ts"

import "./HorizontalOption.vue?vue&type=style&index=0&id=4d230bd8&lang=scss&scoped=true"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d230bd8"]])

export default __exports__